import { render } from "./InvoiceTypeChip.vue?vue&type=template&id=be19f3a8"
import script from "./InvoiceTypeChip.vue?vue&type=script&lang=js"
export * from "./InvoiceTypeChip.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__